<template>
    <th>
        <div class="d-flex align-items-center justify-content-center table-head">
           <div class="table-head-title">
                {{text | capitalize}}
           </div>
            <div class="th-controls" v-if="showControls">
                <div class="headerSortUp"
                     @click="$emit('sort', {sortType, mode: 'asc'})">
                </div>
                <div class="headerSortDown"
                     @click="$emit('sort', {sortType, mode: 'desc'})">
                </div>
            </div>
        </div>
    </th>
</template>
<script type="text/babel">
import Filters from '../../../../mixins/CphFilters.vue';

export default {
    name: 'TableHeadWithSort',
    props: {
        sortType: {
            type: String
        },
        text: {
            type: String
        },
        showControls: {
            type: Boolean,
            default: true
        }
    },
    mixins: [Filters]
};
</script>

<style type="scss">
    .table-head {
        height: 30px;
    }
    .th-controls {
        display: inline-block;
        height: 30px;
        width: 25px;
        margin-left: 5px;
    }
    
    .headerSortDown:after,
    .headerSortUp:after {
        content: ' ';
        position: absolute;
        left: 1px;
        border: 7px solid transparent;
    }
    
    .headerSortDown:after {
        border-top-color: silver;
    }
    
    .headerSortDown:hover:after {
        border-top-color: black;
    }
    
    .headerSortUp:after {
        border-bottom-color: silver;
    }
    .headerSortUp:hover:after {
        border-bottom-color: black;
    }

    .headerSortDown,
    .headerSortUp {
        position: relative;
        height: 18px;
    }
</style>
